<template>
  <el-aside class="admin-aside" width="240px" v-cloak>
    <!-- 演示 logoJP -->
    <!--    <div class="logoJP"></div>-->
    <!--    <div class="logotc"></div>-->
    <!--		<div :class="version!=1?(version!=3?'logo':'logotc'):'logoTHK'"></div>-->
    <div :class="logoClass" style="color: black"></div>
    <div class="admin-menu-list">
      <el-menu :default-active="activeMenu" class="el-menu-vertical" active-text-color="#45c4a1"
               @select="handleSelect">
        <!--				<el-menu-item index="/static/home" @click="activeNameFun('/static/home','状态监视')"-->
        <!--					v-if="MenuRoleList.indexOf('1')>=0&&version!=1">状态监视</el-menu-item>-->

        <el-submenu index="home" v-if="MenuRoleList.indexOf('1')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_634') }}</span>
          </template>
          <el-menu-item index="/static/taskMap" @click="activeNameFun('/static/taskMap','任务地图')">{{ $t('label_634') }}
          </el-menu-item>
<!--          <el-menu-item index="/static/home" @click="activeNameFun('/static/home','任务日历')">{{ $t('label_81') }}-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="/static/timeFault" @click="activeNameFun('/static/timeFault','实时故障')">-->
<!--            {{ $t('label_638') }}-->
<!--          </el-menu-item>-->
        </el-submenu>
        <el-submenu index="spot" v-if="version!=1&&MenuRoleList.indexOf('36')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_217') }}</span>
          </template>
          <el-menu-item @click="activeNameFun('/static/spotCheckPage')" index="/static/spotCheckPage"
                        v-if="MenuRoleList.indexOf('37')>=0">{{ $t('label_740') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/spotResumePage')" index="/static/spotResumePage"
                        v-if="MenuRoleList.indexOf('41')>=0">{{ $t('label_750') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/spotCountPage')" index="/static/spotCountPage"
                        v-if="MenuRoleList.indexOf('42')>=0">{{ $t('label_751') }}
          </el-menu-item>
<!--		  <el-menu-item @click="activeNameFun('/static/spotDeletePage')" index="/static/spotDeletePage"-->
<!--		                v-if="MenuRoleList.indexOf('421')>=0">{{ $t('label_965') }}-->
<!--		  </el-menu-item>-->
        </el-submenu>
        <el-submenu index="maintain" v-if="version!=1&&MenuRoleList.indexOf('105')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_692') }}</span>
          </template>
          <el-menu-item @click="activeNameFun('/static/maintainPlanPage')" index="/static/maintainPlanPage"
                        v-if="MenuRoleList.indexOf('106')>=0">{{ $t('label_427') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/maintainResumePage')"
                        index="/static/maintainResumePage" v-if="MenuRoleList.indexOf('119')>=0">{{ $t('label_590') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/maintainCountPage')" index="/static/maintainCountPage"
                        v-if="MenuRoleList.indexOf('122')>=0">{{ $t('label_88') }}
          </el-menu-item>
        </el-submenu>
        <el-submenu index="6" v-if="version!=1&&MenuRoleList.indexOf('170')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_694') }}</span>
          </template>
          <el-menu-item @click="activeNameFun('/static/EquipmentInspection')"
                        index="/static/EquipmentInspection" v-if="MenuRoleList.indexOf('171')>=0">{{ $t('label_102') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/InspectionRecord')" index="/static/InspectionRecord"
                        v-if="MenuRoleList.indexOf('177')>=0">{{ $t('label_206') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/InspectionStatistics')"
                        index="/static/InspectionStatistics" v-if="MenuRoleList.indexOf('179')>=0">{{ $t('label_269') }}
          </el-menu-item>
        </el-submenu>
        <el-submenu index="malfunction" v-if="version!=1&&MenuRoleList.indexOf('152')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_287') }}</span>
          </template>
          <el-menu-item index="/static/malfunctionRepairPage"
                        @click="activeNameFun('/static/malfunctionRepairPage')" v-if="MenuRoleList.indexOf('153')>=0">
            {{ $t('label_287') }}
          </el-menu-item>
          <el-menu-item index="/static/malfunctionResumePage"
                        @click="activeNameFun('/static/malfunctionResumePage')" v-if="MenuRoleList.indexOf('154')>=0">
            {{ $t('label_697') }}
          </el-menu-item>
          <el-menu-item index="/static/malfunctionCountPage"
                        @click="activeNameFun('/static/maintainCountPage')" v-if="MenuRoleList.indexOf('155')>=0">
            {{ $t('label_699') }}
          </el-menu-item>
          <el-menu-item index="/static/malfunctionKnowledgePage"
                        @click="activeNameFun('/static/malfunctionKnowledgePage')"
                        v-if="MenuRoleList.indexOf('156')>=0">{{ $t('label_701') }}
          </el-menu-item>
        </el-submenu>
        <!-- <el-submenu index="equipmentOperation" v-if="MenuRoleList.indexOf('399')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_510') }}</span>
          </template>
          <el-menu-item @click="activeNameFun('/static/Dashboard','仪表盘')" index="/static/Dashboard"
                        v-if="MenuRoleList.indexOf('400')>=0">{{ $t('label_511') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/signalLamp','信号灯')" index="/static/signalLamp"
                        v-if="MenuRoleList.indexOf('401')>=0">{{ $t('label_513') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/quipmentMonitoring','设备监视')"
                        index="/static/quipmentMonitoring" v-if="MenuRoleList.indexOf('402')>=0">{{ $t('label_515') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/kpiStatistics','KPI统计')" index="/static/kpiStatistics"
                        v-if="MenuRoleList.indexOf('407')>=0">{{ $t('label_517') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/mobileAnalysis','稼动分析')" index="/static/mobileAnalysis"
                        v-if="MenuRoleList.indexOf('411')>=0">{{ $t('label_519') }}
          </el-menu-item>
        </el-submenu> -->
      <!--  <el-submenu index="equipmentOperation" v-if="MenuRoleList.indexOf('299')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_510') }}</span>
          </template>
          <el-menu-item @click="activeNameFun('/static/Dashboard','仪表盘')" index="/static/Dashboard"
                        v-if="MenuRoleList.indexOf('300')>=0">{{ $t('label_511') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/signalLamp','信号灯')" index="/static/signalLamp"
                        v-if="MenuRoleList.indexOf('301')>=0">{{ $t('label_513') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/quipmentMonitoring','设备监视')"
                        index="/static/quipmentMonitoring" v-if="MenuRoleList.indexOf('302')>=0">{{ $t('label_515') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/kpiStatistics','KPI统计')" index="/static/kpiStatistics"
                        v-if="MenuRoleList.indexOf('307')>=0">{{ $t('label_517') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/mobileAnalysis','稼动分析')" index="/static/mobileAnalysis"
                        v-if="MenuRoleList.indexOf('311')>=0">{{ $t('label_519') }}
          </el-menu-item>
        </el-submenu> -->
        <el-submenu index="contract" v-if="MenuRoleList.indexOf('416')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_642') }}</span>
          </template>
          <el-menu-item index="/static/contract" @click="activeNameFun('/static/contract','合同起草')">
            {{ $t('label_646') }}
          </el-menu-item>
          <el-menu-item index="disabled" disabled>{{ $t('label_679') }}</el-menu-item>
        </el-submenu>
        <!--				<el-submenu index="equipmentOperation" v-if="version==1&&MenuRoleList.indexOf('99')>=0">-->
        <el-submenu index="8" v-if="version!=1&&MenuRoleList.indexOf('212')>=0 && false">
          <template slot="title">
            <span slot="title">审批管理</span>
          </template>
          <el-menu-item @click="activeNameFun('/static/malfunctionApprove')"
                        index="/static/malfunctionApprove" v-if="MenuRoleList.indexOf('213')>=0">工单审批
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/malfunctionApproveView')"
                        index="/static/malfunctionApproveView" v-if="MenuRoleList.indexOf('216')>=0">工单查看
          </el-menu-item>
        </el-submenu>
        <el-submenu index="7" v-if="version!=1&&MenuRoleList.indexOf('300')>=0 && false">
          <template slot="title">
            <span slot="title">统计分析</span>
          </template>
          <el-menu-item @click="activeNameFun('/static/causeStatistics')" index="/static/causeStatistics"
                        v-if="MenuRoleList.indexOf('301')>=0">设备状态统计
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/equipmentDesign')" index="/static/equipmentDesign"
                        v-if="MenuRoleList.indexOf('302')>=0">设备故障统计
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/faultStatistics')" index="/static/faultStatistics"
                        v-if="MenuRoleList.indexOf('303')>=0">故障原因统计
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/maintenanceStatistics')"
                        index="/static/maintenanceStatistics"
                        v-if="MenuRoleList.indexOf('304')>=0">维修工作量统计
          </el-menu-item>
        </el-submenu>

        <el-submenu index="5" v-if="version!=1&&MenuRoleList.indexOf('132')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_703') }}</span>
          </template>
          <el-menu-item @click="activeNameFun('/static/partInfo')" index="/static/partInfo"
                        v-if="MenuRoleList.indexOf('133')>=0">{{ $t('label_119') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/locationManagement')"
                        index="/static/locationManagement" v-if="MenuRoleList.indexOf('138')>=0">{{ $t('label_308') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/Warehousing')" index="/static/Warehousing"
                        v-if="MenuRoleList.indexOf('142')>=0">{{ $t('label_352') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/exwarehouse')" index="/static/exwarehouse"
                        v-if="MenuRoleList.indexOf('143')>=0">{{ $t('label_597') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/outRecord')" index="/static/outRecord"
                        v-if="MenuRoleList.indexOf('144')>=0">{{ $t('label_375') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/stock')" index="/static/stock"
                        v-if="MenuRoleList.indexOf('145')>=0">{{ $t('label_407') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/inventoryTask')" index="/static/inventoryTask"
                        v-if="MenuRoleList.indexOf('146')>=0">{{ $t('label_419') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/inventoryRecord')" index="/static/inventoryRecord"
                        v-if="MenuRoleList.indexOf('147')>=0">{{ $t('label_431') }}
          </el-menu-item>
        </el-submenu>

        <el-submenu index="2" v-if="MenuRoleList.indexOf('2')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_689') }}</span>
          </template>
          <el-menu-item @click="activeNameFun('/static/fileFactory','设备厂商管理')" index="/static/fileFactory"
                        v-if="version!=1&&MenuRoleList.indexOf('3')>=0">{{ $t('label_396') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/deviceTypePage','设备类型管理')"
                        index="/static/deviceTypePage" v-if="MenuRoleList.indexOf('8')>=0">{{ $t('label_332') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/deviceFilePage','设备档案')" index="/static/deviceFilePage"
                        v-if="MenuRoleList.indexOf('32')>=0">{{ $t('label_690') }}
          </el-menu-item>
        </el-submenu>

        <el-submenu index="4" v-if="MenuRoleList.indexOf('44')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_705') }}</span>
          </template>
          <!--<el-menu-item @click="activeNameFun('/static/stationPage')" index="/static/stationPage">设备管理</el-menu-item>-->
          <el-menu-item @click="activeNameFun('/static/organization','组织结构')" index="/static/organization"
                        v-if="MenuRoleList.indexOf('45')>=0">{{ $t('label_304') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/userPage','用户管理')" index="/static/userPage"
                        v-if="MenuRoleList.indexOf('54')>=0">{{ $t('label_708') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/timePage','时间管理')" index="/static/timePage"
                        v-if="MenuRoleList.indexOf('59')>=0">{{ $t('label_711') }}
          </el-menu-item>
          <!-- <el-menu-item @click="activeNameFun('/static/rolePage')" index="/static/rolePage">角色管理</el-menu-item> -->
          <el-menu-item @click="activeNameFun('/static/riskPage','风险内容管理')" index="/static/riskPage"
                        v-if="version!=1&&MenuRoleList.indexOf('60')>=0">{{ $t('label_713') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/dictPage','字典管理')" index="/static/dictPage"
                        v-if="MenuRoleList.indexOf('64')>=0">{{ $t('label_715') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/i18nPage','多语言设定')" index="/static/i18nPage"
                        v-if="MenuRoleList.indexOf('305')>=0">{{ $t('label_753') }}
          </el-menu-item>
          <el-menu-item @click="activeNameFun('/static/paramPage','参数设定')" index="/static/paramPage"
                        v-if="MenuRoleList.indexOf('308')>=0">{{ $t('label_763') }}
          </el-menu-item>
<!--          <el-menu-item @click="activeNameFun('/static/customerPage','客户管理')" index="/static/customerPage"-->
<!--                        v-if="MenuRoleList.indexOf('308')>=0">{{$t('label_853')}}</el-menu-item>-->
          <el-menu-item @click="activeNameFun('/static/warningTimePage','预警时间管理')"
                        index="/static/warningTimePage" v-if="version!=1&&MenuRoleList.indexOf('68')>=0">
            {{ $t('label_718') }}
          </el-menu-item>
        </el-submenu>
        <!-- <el-submenu index="8" v-if="MenuRoleList.indexOf('44')>=0">
          <template slot="title">
            <span slot="title">技改管理</span>
          </template>
          <el-menu-item @click="activeNameFun('/static/planResume')" index="/static/planResume" v-if="MenuRoleList.indexOf('45')>=0">计划履历</el-menu-item>
          <el-menu-item @click="activeNameFun('/static/transformationStatistics')" index="/static/transformationStatistics" v-if="MenuRoleList.indexOf('54')>=0">技改统计</el-menu-item>
        </el-submenu> -->

        <el-submenu index="systemManage" v-if="false">
          <template slot="title">
            <span slot="title">系统管理</span>
          </template>
          <el-menu-item @click="activeNameFun('/operlog','操作日志')" index="/operlog">操作日志</el-menu-item>
          <el-menu-item @click="activeNameFun('/server','服务监控')" index="/server">服务监控</el-menu-item>
          <el-menu-item @click="activeNameFun('/cache','缓存监控')" index="/cache">缓存监控</el-menu-item>
        </el-submenu>

        <el-submenu index="7" v-if="MenuRoleList.indexOf('423')>=0">
          <template slot="title">
            <span slot="title">{{ $t('label_1001') }}</span>
          </template>
          <el-menu-item v-if="MenuRoleList.indexOf('424')>=0" @click="activeNameFun('/static/sparePartsStatistics')" index="/static/sparePartsStatistics">{{ $t('label_1002') }}</el-menu-item>
          <el-menu-item v-if="MenuRoleList.indexOf('425')>=0" @click="activeNameFun('/static/checkStatistics')" index="/static/checkStatistics">{{ $t('label_1015') }}</el-menu-item>
          <el-menu-item v-if="MenuRoleList.indexOf('301')>=0" @click="activeNameFun('/static/causeStatistics')" index="/static/causeStatistics">{{ $t('label_1011') }}</el-menu-item>
          <el-menu-item v-if="MenuRoleList.indexOf('302')>=0" @click="activeNameFun('/static/equipmentDesign')" index="/static/equipmentDesign">{{ $t('label_1012') }}</el-menu-item>
          <el-menu-item v-if="MenuRoleList.indexOf('303')>=0" @click="activeNameFun('/static/faultStatistics')" index="/static/faultStatistics">{{ $t('label_1013') }}</el-menu-item>
          <el-menu-item v-if="MenuRoleList.indexOf('304')>=0" @click="activeNameFun('/static/maintenanceStatistics')" index="/static/maintenanceStatistics">{{ $t('label_1014') }}</el-menu-item>

        </el-submenu>
      </el-menu>
    </div>
  </el-aside>
</template>

<script>
import utils from "@/utils/utils.js";

export default {
  name: 'AdminMenu',
  props: {},
  data() {
    return {
      activeMenu: '/static/home',
      activeName: '',
      version: '',
      MenuRoleList: [],
      logoClass: this.$store.getters.getLogoClass
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      utils.clearTime();
      this.activeMenu = key;
      this.$store.commit('setActiveMenu', key);
      this.$router.push({
        path: key
      });
    },
    activeNameFun(item, title) {
      if (title && (this.$store.getters.getVersions == 1)) {
        // document.title = '设备运维管理系统_' + title;
      } else {
        // document.title = '设备运维管理系统';
      }
      this.$store.commit('setActiveName', item);
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    },
    test2(key) {
      this.activeMenu = key
      // this.$store.commit('setActiveMenu', key);
      this.$store.commit('setActiveName', key);
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
      this.$router.push({
        path: key
      });
    }
  },
  beforeCreate() {
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    } else if (Glod) {
      if (Glod.BaseUrl != '' && Glod.BaseUrl != null && Glod.BaseUrl != undefined) {
        this.$store.commit('setPostUrl', Glod.BaseUrl);
      }
      if (Glod.Version > 0) {
        this.versions = Glod.Version;
        this.$store.commit('setVersions', Glod.Version);
      }
      if (Glod.AppDownloadURL != '' && Glod.AppDownloadURL != null && Glod.AppDownloadURL != undefined) {
        this.$store.commit('setAppDownloadURL', Glod.AppDownloadURL);
      }
      if (Glod.DownloadAppFlag >= 0) {
        this.$store.commit('setDownloadAppFlag', Glod.DownloadAppFlag);
      }
      if (Glod.LogoClass != '' && Glod.LogoClass != null && Glod.LogoClass != undefined) {
        this.$store.commit('setLogoClass', Glod.LogoClass);
      }
      if (Glod.ShowMap != undefined && Glod.ShowMap != null && Glod.ShowMap != '') {
        this.$store.commit('setShowMap', Glod.ShowMap);
      }
    }
  },
  created() {
    // if (sessionStorage.getItem('store')) {
    // 	this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    // }
    this.version = this.$store.getters.getVersions;
  },
  mounted() {
    this.activeMenu = this.$store.getters.getActiveMenu;
    this.MenuRoleList = this.$store.getters.getMenu;
    window.test2 = this.test2;
    /*this.$router.push({
      path: this.activeMenu
    });*/
  }
}
</script>

<style>
[v-cloak] {
  display: none !important;
}

.admin-menu-list {
  padding-top: 60px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.admin-menu-list > div {
  position: relative;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: auto;
}

.el-menu.el-menu-vertical {
  border: 0;
}

.admin-menu-list .el-submenu.is-active.is-opened,
.admin-menu-list .el-submenu.is-opened {
  background: #44474e;
  color: #ffffff;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background: #44474e;
  color: #ffffff;
}

.el-submenu__title:focus {
  background: #44474e;
  color: #ffffff;
}

.admin-menu-list .el-submenu__title:hover {
  background: #44474e;
  color: #ffffff;
}

.el-submenu.is-active.is-opened .el-menu,
.el-submenu.is-opened .el-menu {
  background: #44474e;
  color: #ffffff;
}

.admin-menu-list .el-submenu.is-active.is-opened .el-submenu__title,
.admin-menu-list .el-submenu.is-opened .el-submenu__title {
  color: #ffffff;
}

.el-submenu.is-active .el-menu-item,
.el-submenu.is-opened .el-menu-item {
  color: #ffffff;
}

.el-submenu.is-active .el-menu-item:focus,
.el-submenu.is-opened .el-menu-item:hover,
.el-submenu.is-active .el-menu-item:hover {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/menu.vue